'use strict';
/**
 * Small, dependency-free helpers shared across the avatar module.
 * Kept pure where possible so they can be unit-tested in isolation.
 */
/** Detect mobile vs desktop the same way the original widget did. */
export function getDeviceType() {
    const isMobile = (navigator.maxTouchPoints > 1) ||
        /Mobi|Android|iPhone|iPad|iPod|BlackBerry|Windows Phone/i.test(navigator.userAgent);
    return isMobile ? 'mobile' : 'desktop';
}
/**
 * Split a long transcript into readable subtitle chunks at phrase boundaries.
 * Ported verbatim (behaviour-preserving) from the original runner page so the
 * on-screen captions read identically.
 *
 * @param text the full transcript so far
 * @param maxCharsPerChunk soft upper bound per chunk
 */
export function chunkSubtitleText(text, maxCharsPerChunk = 160) {
    const normalizedText = typeof text === 'string' ? text.replace(/\s+/g, ' ').trim() : '';
    if (!normalizedText)
        return [];
    const words = normalizedText.split(' ');
    const chunks = [];
    let currentChunk = '';
    for (const word of words) {
        const nextChunk = currentChunk ? `${currentChunk} ${word}` : word;
        const exceedsTarget = nextChunk.length > maxCharsPerChunk;
        const endsPhrase = /[.!?;:]$/.test(word) || /,$/.test(word);
        const chunkIsEstablished = currentChunk.length >= Math.round(maxCharsPerChunk * 0.6);
        if (currentChunk && (exceedsTarget || (endsPhrase && chunkIsEstablished))) {
            chunks.push(currentChunk);
            currentChunk = word;
            continue;
        }
        currentChunk = nextChunk;
    }
    if (currentChunk) {
        chunks.push(currentChunk);
    }
    return chunks;
}
